import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-label',
  template: `
    <label [class]="alignClass" >
      <span [innerHTML]="labelText" class="clsLabelText"></span>
    </label>
  `,
  styleUrls: ['./label.component.less']
})
export class LabelComponent extends FieldType {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  get alignClass() {
    return this.to.labelAlign ? this.to.labelAlign : 'end';
  }

  get labelText() { return (this.to.labelText) ? this.to.labelText : '' };

  onLabelClick($event: any) {
    if (this.to.onLblClick) {
      this.to.onLblClick($event);
    }
  }

}
